var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:'main-node',class:{'node': true, 'nodeInit': _vm.node.init }},[_c('div',{staticClass:"node-content"},[_c('pre',[_vm._v(_vm._s(_vm.node.position))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }